
import Swiper, { Pagination, EffectFade, Autoplay } from 'swiper';

$(document).ready(function() {
  var swiper = new Swiper(".completeLook", {
    slidesPerView: 3,
    spaceBetween: 8,
    freeMode: true,
    draggable: true,
    direction: 'horizontal',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    
  });


$(document).on('click','.add-to-cart-ajax-button',function(){
  var quantity = 1
  var id= $(this).attr('data-product-id');
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {id:id,quantity:quantity},
      success: function() {
        document.querySelector('.js-drawer-open-button-right').click();
    },
    error: function(XMLHttpRequest, textStatus) {
        alert("An error occurred: can't reach server");
    },
  });
})
});


